/**
 * Partner-Referenz-Erfassung (Haspa-Kooperation, Spec
 * docs/superpowers/specs/2026-08-06-partner-api-haspa-design.md):
 * `?partner=<name>&partnerUserId=<id>` wirkt auf JEDER Seite (App-weiter
 * Effekt in src/app.js) und wird 30 Tage in localStorage gehalten, bis sie
 * beim Signup bzw. per POST /api/vansite/partner-ref am User landet.
 * First-wins wird server-seitig durchgesetzt; hier gewinnt der letzte Link.
 * Allowlist: nur bekannte Partner — first-wins-Felder dürfen nie mit
 * Freitext aus einem manipulierten Link gefüllt werden. Bewusst ohne
 * moment (läuft im App-Entry-Graph, Bundle-Size).
 */
export const PARTNER_REF_KEY = 'vansite.partnerRef';
export const KNOWN_PARTNER_NAMES = ['haspa'];
const PARTNER_REF_TTL_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;
const MAX_PARAM_LENGTH = 100;

// Safari mit "Block all cookies" wirft SecurityError schon beim Zugriff auf
// window.localStorage (nicht erst beim Schreiben), und im privaten Modus kann
// setItem am Quota scheitern. Beides darf weder den App-Root-Effekt (src/app.js)
// noch den fire-and-forget-Sync aus fetchCurrentUser umbringen.
export const clearPartnerRef = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PARTNER_REF_KEY);
  } catch (e) {
    // no-op: ohne Storage gibt es auch nichts zu löschen
  }
};

export const capturePartnerRefFromUrl = (search) => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(search != null ? search : window.location.search);
  const partnerName = (params.get('partner') || '').slice(0, MAX_PARAM_LENGTH).trim().toLowerCase();
  const partnerUserId = (params.get('partnerUserId') || '').slice(0, MAX_PARAM_LENGTH).trim();
  if (!partnerName || !partnerUserId || !KNOWN_PARTNER_NAMES.includes(partnerName)) return null;
  const ref = {
    partnerName,
    partnerUserId,
    expires: new Date(Date.now() + PARTNER_REF_TTL_DAYS * DAY_MS).toISOString(),
  };
  try {
    window.localStorage.setItem(PARTNER_REF_KEY, JSON.stringify(ref));
  } catch (e) {
    // Ohne Storage keine spätere Nachtragung — Attribution geht verloren, aber
    // die App darf daran nicht scheitern.
    return null;
  }
  return ref;
};

export const getPartnerRef = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(PARTNER_REF_KEY);
    if (!raw) return null;
    const ref = JSON.parse(raw);
    if (!ref.partnerName || !ref.partnerUserId || Date.now() > new Date(ref.expires).getTime()) {
      clearPartnerRef();
      return null;
    }
    return { partnerName: ref.partnerName, partnerUserId: ref.partnerUserId };
  } catch (e) {
    return null;
  }
};
